import { isTrialWordExperiment } from 'src/data/abTests';
import { useCurrentCustomer } from 'src/store';

export const useTrialWordsLimit = () => {
  const currentCustomer = useCurrentCustomer();
  const isExperiment = isTrialWordExperiment(currentCustomer);

  return isExperiment ? 2500 : 5000;
};
